// src/utils/sitemapGenerator.js
export const generateSitemap = (baseUrl = 'https://admin.chema.com') => {
    const pages = [
        { url: '/', priority: 1.0, changefreq: 'daily' },
        { url: '/members', priority: 0.9, changefreq: 'daily' },
        { url: '/claims', priority: 0.9, changefreq: 'daily' },
        { url: '/vouchers', priority: 0.8, changefreq: 'weekly' },
        // Employee, profile, and settings pages are excluded from sitemap for security
    ];

    const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemap.org/schemas/sitemap/0.9">
  ${pages.map(page => `
    <url>
      <loc>${baseUrl}${page.url}</loc>
      <lastmod>${new Date().toISOString().split('T')[0]}</lastmod>
      <changefreq>${page.changefreq}</changefreq>
      <priority>${page.priority}</priority>
    </url>
  `).join('')}
</urlset>`;

    return sitemap;
};

export const generateRobotsTxt = (baseUrl = 'https://admin.chema.com') => {
    return `# https://www.robotstxt.org/robotstxt.html
User-agent: *
Allow: /

# Administrative pages should not be indexed
Disallow: /employees
Disallow: /profile
Disallow: /settings
Disallow: /login

# Sitemap
Sitemap: ${baseUrl}/sitemap.xml`;
};